import React from 'react';
import { Image, View, StyleSheet, Dimensions } from 'react-native';

const deviceWidth = Dimensions.get('window').width;

const imageProportions = {
  a4: 1.4,
  square: 1,
};

const justifyContentValue = {
  top: 'flex-start',
  center: 'center',
  bottom: 'flex-end',
};

export default function MaskedImageContainer({
  uri,
  imageProportionType,
  imageWidthRelativeToDeviceWidth,
  maskWidthRelativeToDeviceWidth,
  maskHeightRelativeToDeviceWidth,
  containerWidthRelativeToDeviceWidth,
  containerHeightRelativeToDeviceWidth,
  verticalAlignment,
}) {
  const imageProportion = imageProportions[imageProportionType];
  if (maskHeightRelativeToDeviceWidth === undefined) {
    maskHeightRelativeToDeviceWidth =
      maskWidthRelativeToDeviceWidth * imageProportion;
  }
  if (containerHeightRelativeToDeviceWidth === undefined) {
    containerHeightRelativeToDeviceWidth =
      maskHeightRelativeToDeviceWidth +
      (containerWidthRelativeToDeviceWidth - maskWidthRelativeToDeviceWidth);
    // containerWidthRelativeToDeviceWidth * imageProportion;
  }

  const imageWidth = imageWidthRelativeToDeviceWidth * deviceWidth;
  const imageHeight =
    imageWidthRelativeToDeviceWidth * deviceWidth * imageProportion;

  const maskWidth = maskWidthRelativeToDeviceWidth * deviceWidth;
  const maskHeight = maskHeightRelativeToDeviceWidth * deviceWidth;

  const containerWidth = deviceWidth * containerWidthRelativeToDeviceWidth;
  const containerHeight = deviceWidth * containerHeightRelativeToDeviceWidth;
  // const containerWidth = deviceWidth * containerWidthRelativeToDeviceWidth;
  // const containerHeight =
  //   maskHeightRelativeToDeviceWidth * deviceWidth +
  //   deviceWidth * (1 - maskWidthRelativeToDeviceWidth);

  const dynamicStyles = StyleSheet.create({
    container: {
      width: containerWidth,
      height: containerHeight,
      justifyContent: 'center',
      alignItems: 'center',
      overflow: 'hidden',
    },
    mask: {
      width: maskWidth,
      height: maskHeight,
      justifyContent: justifyContentValue[verticalAlignment],
      alignItems: 'center',
      overflow: 'hidden',
    },
    image: {
      width: imageWidth,
      height: imageHeight,
    },
  });
  return (
    <View style={dynamicStyles.container}>
      <View style={dynamicStyles.mask}>
        <Image style={dynamicStyles.image} source={{ uri }} />
      </View>
    </View>
  );
}
